export class AutoLoginStrategy {
  private static readonly KEY_STORAGE_ACCESSTOKEN = '_key_auto_login_access_token';
  private static readonly KEY_STORAGE_REFRESHTOKEN = '_key_auto_login_refresh_token';

  public static setToken( access_token: string ) {
    sessionStorage.setItem(this.KEY_STORAGE_ACCESSTOKEN, access_token);
  }

  public static getAccessToken() {
    return sessionStorage.getItem(this.KEY_STORAGE_ACCESSTOKEN);
  }

  public static hasToken() {
    return this.getAccessToken() !== null
  }

  public static setRefreshToken( access_token: string ) {
    sessionStorage.setItem(this.KEY_STORAGE_REFRESHTOKEN, access_token);
  }

  public static getRefreshToken() {
    return sessionStorage.getItem(this.KEY_STORAGE_REFRESHTOKEN);
  }

  public static hasRefreshToken() {
    return this.getRefreshToken() !== null
  }

  public static removeLocalData(){
    sessionStorage.removeItem(this.KEY_STORAGE_ACCESSTOKEN);
    sessionStorage.removeItem(this.KEY_STORAGE_REFRESHTOKEN);
  }
}
